import Footer from 'components/global/footer'
import Navbar from 'components/global/navbar'
import React from 'react'
import { Link } from 'react-router-dom'

const Login = () => {
    return (
        <div>
            <Navbar />
            <div className='mt-12 px-4'>
                <h3 className='text-2xl font-bold text-primary text-center'>
                    Login
                </h3>
                <div className='mt-8 light-shadow rounded-md sm:p-6 py-6 px-4 lg:w-1/2 md:w-[75%] sm:w-[85%] w-full mx-auto'>
                    <p className='mb-8 text-lg text-center font-semibold'>
                        Login to your account
                    </p>
                    <form>
                        <div className='mt-8 flex flex-col gap-6'>
                            <div className='flex flex-col gap-1.5 w-full'>
                                <label className='text-dark font-semibold text-[15px]'>
                                    Email or username
                                </label>
                                <input 
                                type="text"
                                className='input text-sm'
                                placeholder='Type here...'
                                />
                            </div>
                            <div className='flex flex-col gap-1.5 w-full'>
                                <label className='text-dark font-semibold text-[15px]'>
                                    Password
                                </label>
                                <input 
                                type="text"
                                className='input text-sm'
                                placeholder='*********'
                                />
                            </div>
                            <div className='mt-4'>
                                <button className="btn-primary py-1.5 w-[150px]">
                                    Submit
                                </button>
                            </div>
                            <div className='flex items-center gap-2 text-sm pb-2'>
                                <p>Don't have an account? </p>
                                <Link to='/register' className='text-primary'>
                                    Register
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className='mt-20'>
                <Footer />
            </div>
        </div>
    )
}

export default Login